import LogoIcon from './LogoIcon'
import FlagIcon from './FlagIcon'
import FooterLogoIcon from './FooterLogoIcon'
import NavRightArrow from './NavRightArrow'
import DownArrow from './DownArrow'
import UpWorkIcon from './UpWorkIcon'
import BehanceIcon from './BehanceIcon'
import ClutchIcon from './ClutchIcon'
import GitHubIcon from './GitHubIcon'
import InstaIcon from './InstaIcon'
import LinkedInIcon from './LinkedInIcon'
import MailIcon from './MailIcon'
import LolliPopIcon from './LolliPopIcon'
import LocationIcon from './LocationIcon'
import TelePhoneIcon from './TelePhoneIcon'
import DoubleRightArrowIcon from './DoubleRightArrowIcon'
import AiMlIcon from './AiMlIcon'
import EcommIcon from './EcommIcon'
import WebAppIcon from './WebAppIcon'
import CustomSoftwareIcon from './CustomSoftwareIcon'
import PhPIcon from './PhPIcon'
import AngularIcon from './AngularIcon'
import PythonDevIcon from './PythonDevIcon'
import BlockChainIcon from './BlockChainIcon'
import NodeJsIcon from './NodeJsIcon'
import JavaIcon from './JavaIcon'
import ReactJsIcons from './ReactJsIcons'
import QAIcons from './QAIcons'
import WebDesignIcons from './WebDesignIcons'
import VueIcon from './VueIcon'
import UiIcons from './UiIcons'
import IphoneIcon from './IphoneIcon'
import AndroiudIcon from './AndroiudIcon'
import FlutterIcons from './FlutterIcons'
import MoboIcon from './MoboIcon'
import LaravelIcons from './LaravelIcons'
import FintechStrategyIcon from './FintechStrategyIcon'
import { AIFinancialIcon } from './AIFinancialIcon'
import { ContinuousSupportIcon } from './ContinuousSupportIcon'
import { CustomFintechIcon } from './CustomFintechIcon'
import { ScalableSolutionsIcon } from './ScalableSolutionsIcon'
import { SeamlessIntegrationIcon } from './SeamlessIntegrationIcon'
import { SecureTransactionsIcon } from './SecureTransactionsIcon'
import EcommerceStrategyIcon from './EcommerceStrategyIcon'
import AIPoweredSalesIcon from './AIPoweredSalesIcon'
import CustomOnlineStoreIcon from './CustomOnlineStoreIcon'
import TravelTourismStrategyIcon from './TravelTourismStrategyIcon'
import CustomTailoredTravelIcons from './CustomTailoredTravelIcons'
import AIDrivenSmartTravelIcon from './AIDrivenSmartTravelIcon'
import OmnichannelTravelIcon from './OmnichannelTravelIcon'
import ScalableCloudBasedIcon from './ScalableCloudBasedIcon'
import RestaurantsAndHospitalityStrategyIcon from './RestaurantsAndHospitalityStrategyIcon'
import CustomHospitalitySoftwareIcon from './CustomHospitalitySoftwareIcon'
import AIPoweredCustomerIcon from './AIPoweredCustomerIcon'
import EducationStrategyIcon from './EducationStrategyIcon'
import CustomEducationSoftwareIcon from './CustomEducationSoftwareIcon'
import AIPoweredLearningIcon from './AIPoweredLearningIcon'
import SecureCompliantIcon from './SecureCompliantIcon'
import OmnichannelLearningIcon from './OmnichannelLearningIcon'
import NewsLetterIcon from './NewsLetterIcon'
import RealestateStrategyIcon from './RealestateStrategyIcon'
import BoostYourRealIcon from './BoostYourRealIcon'
import TailoredRealEstateIcon from './TailoredRealEstateIcon'
import AIBigDataIcon from './AIBigDataIcon'
import SecureCompliantPlatformsIcon from './SecureCompliantPlatformsIcon'
import OmnichannelUserExperienceIcon from './OmnichannelUserExperienceIcon'
import HealthFitnessStrategyIcon from './HealthFitnessStrategyIcon'
import CustomHealthFitnessIcon from './CustomHealthFitnessIcon'
import AIPoweredHealthInsightsIcon from './AIPoweredHealthInsightsIcon'
import SecureCompliantDataIcon from './SecureCompliantDataIcon'
import WearablesHealthIcon from './WearablesHealthIcon'
import AiThatLearns from './techIcons/AiThatLearns'
import AutomationAndSmart from './techIcons/AutomationAndSmart'
import CostEffective from './techIcons/CostEffective'
import HumanLike from './techIcons/HumanLike'
import IndustrySpefific from './techIcons/IndustrySpefific'
import MultiChannel from './techIcons/MultiChannel'
import Personalized from './techIcons/Personalized'
import SecureCompliant from './techIcons/SecureCompliant'
import Twenty4By7 from './techIcons/Twenty4By7'
import CategorizationOfSoftwareSolutionsIcon from './CategorizationOfSoftwareSolutionsIcon'
import SupplyChainFromStrategyIcon from './SupplyChainFromStrategyIcon'
import CustomLogisticsSoftwareIcon from './CustomLogisticsSoftwareIcon'
import AIPoweredLogisticsAnalyticsIcon from './AIPoweredLogisticsAnalyticsIcon'
import SupplySecureCompliantPlatformsIcon from './SupplySecureCompliantPlatformsIcon'
import GamingFromStrategyIcon from './GamingFromStrategyIcon'
import AdvancedFeaturesIcon from './AdvancedFeaturesIcon'
import CustomGameSolutionsIcon from './CustomGameSolutionsIcon'
import AIPoweredGamingIcon from './AIPoweredGamingIcon'
import SecureBlockchainGamingIcon from './SecureBlockchainGamingIcon'
import SeamlessMultiplayerIntegrationIcon from './SeamlessMultiplayerIntegrationIcon'
import SocialFromStrategyIcon from './SocialFromStrategyIcon'
import CustomSocialNetworksIcon from './CustomSocialNetworksIcon'
import AIPoweredEngagementToolsIcon from './AIPoweredEngagementToolsIcon'
import SecurePrivateNetworkingIcon from './SecurePrivateNetworkingIcon'
import MediaFromStrategyIcon from './MediaFromStrategyIcon'
import CustomMediaPlatformsIcon from './CustomMediaPlatformsIcon'
import AIPoweredAudienceInsightsIcon from './AIPoweredAudienceInsightsIcon'
import GovernmentFromStrategyIcon from './GovernmentFromStrategyIcon'
import CustomGovernmentSoftwareIcon from './CustomGovernmentSoftwareIcon'
import AIPoweredPublicInsightsIcon from './AIPoweredPublicInsightsIcon'
import CustomChatBOtIcon from './techIcons/CustomChatBOtIcon'
import ClickHereNOwIon from './ClickHereNOwIon'
import MOdelTrainingIcon from './techIcons/MOdelTrainingIcon'
import PredictiveAnalysisIcon from './techIcons/PredictiveAnalysisIcon'
import VirtualAssistantIcon from './techIcons/VirtualAssistantIcon'
import GenAiIcon from './techIcons/GenAiIcon'
import AspNetIcon from './techIcons/AspNetIcon'
import CodeIgnitorIcon from './techIcons/CodeIgnitorIcon'
import JavaSIcon from './techIcons/JavaSIcon'
import LaravelSIcon from './techIcons/LaravelSIcon'
import NodeJsSIcon from './techIcons/NodeJsSIcon'
import PhpSIcon from './techIcons/PhpIcon'
import PythionSIcon from './techIcons/PythionSIcon'
import RoRSIcons from './techIcons/RoRSIcons'
import SolidityIcon from './technologies/blockchainIcons/SolidityIcon'
import EthereumIcons from './technologies/blockchainIcons/EthereumIcons'
import HardhatIcons from './technologies/blockchainIcons/HardhatIcons'
import KubernateIcons from './technologies/blockchainIcons/KubernateIcons'
import RustSIcons from './technologies/blockchainIcons/RustSIcons'
import SolanaIcons from './technologies/blockchainIcons/SolanaIcons'
import Web3Icons from './technologies/blockchainIcons/Web3Icons'
import AndroidIcon from './technologies/mobile/AndroidIcon'
import AndroidFromStrategyIcon from './technologies/mobile/AndroidFromStrategyIcon'
import IOSIcon from './technologies/mobile/IOSIcon'
import IOSFromStrategyIcon from './technologies/mobile/IOSFromStrategyIcon'
import FlutterIcon from './technologies/mobile/FlutterIcon'
import FlutterFromStrategyIcon from './technologies/mobile/FlutterFromStrategyIcon'
import ReactNativeIcon from './technologies/mobile/ReactNativeIcon'
import ReactNativeFromStrategyIcon from './technologies/mobile/ReactNativeFromStrategyIcon'
import BigCommerceIcon from './technologies/EcommerceIcons/BigCommerceIcon'
import MagentoIcon from './technologies/EcommerceIcons/MagentoIcon'
import BigCommBigIcon from './technologies/EcommerceIcons/HeroSectionImgs/BigCommBigIcon'
import MagentoBigIcon from './technologies/EcommerceIcons/HeroSectionImgs/MagentoBigIcon'
import ShopifyBigIcon from './technologies/EcommerceIcons/HeroSectionImgs/ShopifyBigIcon'
import WooBigIcon from './technologies/EcommerceIcons/HeroSectionImgs/WooBigIcon'
import WebFLowBigIcon from './technologies/EcommerceIcons/HeroSectionImgs/WebFLowBigIcon'
import WooCommercex from './technologies/EcommerceIcons/WooCommerce'
import BlockChainServiceIcon from './servicesIcons/BlockChainIcon'
import AimlHero from './servicesIcons/AimlHero'
import CustomSoftwareSSIcon from './servicesIcons/CustomSoftwareIcon'
import EcommSrviceIcon from './servicesIcons/EcommSrviceIcon'
import MobileServiceIcon from './servicesIcons/MobileServiceIcon'
import PwaServiceIcon from './servicesIcons/PwaServiceIcon'
import QAserviceIcon from './servicesIcons/QAserviceIcon'
import WebApServiceIcon from './servicesIcons/WebApServiceIcon'
import WebDesIcon from './servicesIcons/WebDesIcon'
import CustomChatIcn from './technologies/AimlBigIcons/CustomChatIcn'
import GebAiIcn from './technologies/AimlBigIcons/GebAiIcn'
import ModelTrainIcn from './technologies/AimlBigIcons/ModelTrain'
import PredAnalyticsIcn from './technologies/AimlBigIcons/PredAnalyticsIcn'
import CaterPillar from './technologies/AimlBigIcons/CaterPillar'
import Chain from './technologies/AimlBigIcons/Chain'
import Ladder from './technologies/AimlBigIcons/Ladder'
import VirtualAssIcn from './technologies/AimlBigIcons/VirtualAssIcn'
import AspBigIcn from './technologies/backendBigIcons/AspBigIcn'
import CodeIgnitIcn from './technologies/backendBigIcons/CodeIgnitIcn'
import JavaBigIcn from './technologies/backendBigIcons/JavaBigIcn'
import LaravelBigIcn from './technologies/backendBigIcons/LaravelBigIcn'
import NodeJsBigIcn from './technologies/backendBigIcons/NodeJsBigIcn'
import PhpBigIcn from './technologies/backendBigIcons/PhpBigIcn'
import PythinBigIcn from './technologies/backendBigIcons/PythinBigIcn'
import RorBigIcn from './technologies/backendBigIcons/RorBigIcn'
import EthereumBigIcn from './technologies/blockchainIcons/blockChainBigIcons/EthereumBigIcn'
import HardhatBigIcn from './technologies/blockchainIcons/blockChainBigIcons/HardhatBigIcn'
import KubernateBigIcn from './technologies/blockchainIcons/blockChainBigIcons/KubernateBigIcn'
import RustBigIcn from './technologies/blockchainIcons/blockChainBigIcons/RustBigIcn'
import SolanaBigIcn from './technologies/blockchainIcons/blockChainBigIcons/SolanaBigIcn'
import SolidityBigIcn from './technologies/blockchainIcons/blockChainBigIcons/SolidityBigIcn'
import WebThreeBigIcn from './technologies/blockchainIcons/blockChainBigIcons/WebThreeBigIcn'
import ProcessSvgIcon from './technologies/blockchainIcons/blockChainBigIcons/ProcessSvgIcon'
import FlagIconIndia from './FlagIconIndia'

export {
   FlagIconIndia,
   WebThreeBigIcn,
   SolanaBigIcn,
   SolidityBigIcn,
   RustBigIcn,
   KubernateBigIcn,
   HardhatBigIcn,
   EthereumBigIcn,
   RorBigIcn,
   PythinBigIcn,
   PhpBigIcn,
   LaravelBigIcn,
   NodeJsBigIcn,
   JavaBigIcn,
   CodeIgnitIcn,
   AspBigIcn,
   VirtualAssIcn,
   Ladder,
   Chain,
   CaterPillar,
   PredAnalyticsIcn,
   ModelTrainIcn,
   GebAiIcn,
   CustomChatIcn,
   WebDesIcon,
   WebApServiceIcon,
   QAserviceIcon,
   PwaServiceIcon,
   MobileServiceIcon,
   EcommSrviceIcon,
   CustomSoftwareSSIcon,
   AimlHero,
   BlockChainServiceIcon,
   WooCommercex,
   WebFLowBigIcon,
   WooBigIcon,
   ShopifyBigIcon,
   MagentoBigIcon,
   BigCommBigIcon,
   MagentoIcon,
   BigCommerceIcon,
   Web3Icons,
   SolanaIcons,
   RustSIcons,
   KubernateIcons,
   HardhatIcons,
   EthereumIcons,
   SolidityIcon,
   RoRSIcons,
   PythionSIcon,
   PhpSIcon,
   NodeJsSIcon,
   JavaSIcon,
   LaravelSIcon,
   CodeIgnitorIcon,
   AspNetIcon,
   PredictiveAnalysisIcon,
   GenAiIcon,
   VirtualAssistantIcon,
   ClickHereNOwIon,
   MOdelTrainingIcon,
   CustomChatBOtIcon,
   AiThatLearns,
   AutomationAndSmart,
   CostEffective,
   HumanLike,
   IndustrySpefific,
   MultiChannel,
   Personalized,
   SecureCompliant,
   Twenty4By7,
   NewsLetterIcon,
   MailIcon,
   LaravelIcons,
   LinkedInIcon,
   InstaIcon,
   GitHubIcon,
   ClutchIcon,
   BehanceIcon,
   LogoIcon,
   FlagIcon,
   FooterLogoIcon,
   NavRightArrow,
   DownArrow,
   UpWorkIcon,
   LolliPopIcon,
   LocationIcon,
   TelePhoneIcon,
   DoubleRightArrowIcon,
   AiMlIcon,
   EcommIcon,
   WebAppIcon,
   CustomSoftwareIcon,
   PhPIcon,
   AngularIcon,
   BlockChainIcon,
   PythonDevIcon,
   NodeJsIcon,
   JavaIcon,
   ReactJsIcons,
   WebDesignIcons,
   VueIcon,
   QAIcons,
   IphoneIcon,
   UiIcons,
   AndroiudIcon,
   MoboIcon,
   FlutterIcons,
   FintechStrategyIcon,
   AIFinancialIcon,
   ContinuousSupportIcon,
   CustomFintechIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureTransactionsIcon,
   EcommerceStrategyIcon,
   AIPoweredSalesIcon,
   CustomOnlineStoreIcon,
   TravelTourismStrategyIcon,
   CustomTailoredTravelIcons,
   AIDrivenSmartTravelIcon,
   OmnichannelTravelIcon,
   ScalableCloudBasedIcon,
   RestaurantsAndHospitalityStrategyIcon,
   CustomHospitalitySoftwareIcon,
   AIPoweredCustomerIcon,
   EducationStrategyIcon,
   CustomEducationSoftwareIcon,
   AIPoweredLearningIcon,
   SecureCompliantIcon,
   OmnichannelLearningIcon,
   RealestateStrategyIcon,
   BoostYourRealIcon,
   TailoredRealEstateIcon,
   AIBigDataIcon,
   SecureCompliantPlatformsIcon,
   OmnichannelUserExperienceIcon,
   HealthFitnessStrategyIcon,
   CustomHealthFitnessIcon,
   AIPoweredHealthInsightsIcon,
   SecureCompliantDataIcon,
   WearablesHealthIcon,
   CategorizationOfSoftwareSolutionsIcon,
   SupplyChainFromStrategyIcon,
   CustomLogisticsSoftwareIcon,
   AIPoweredLogisticsAnalyticsIcon,
   SupplySecureCompliantPlatformsIcon,
   GamingFromStrategyIcon,
   AdvancedFeaturesIcon,
   CustomGameSolutionsIcon,
   AIPoweredGamingIcon,
   SecureBlockchainGamingIcon,
   SeamlessMultiplayerIntegrationIcon,
   SocialFromStrategyIcon,
   CustomSocialNetworksIcon,
   AIPoweredEngagementToolsIcon,
   SecurePrivateNetworkingIcon,
   MediaFromStrategyIcon,
   CustomMediaPlatformsIcon,
   AIPoweredAudienceInsightsIcon,
   GovernmentFromStrategyIcon,
   CustomGovernmentSoftwareIcon,
   AIPoweredPublicInsightsIcon,
   AndroidIcon,
   AndroidFromStrategyIcon,
   IOSIcon,
   IOSFromStrategyIcon,
   FlutterIcon,
   FlutterFromStrategyIcon,
   ReactNativeIcon,
   ReactNativeFromStrategyIcon,
   ProcessSvgIcon
}
